import * as THREE from "three";
import { RoadData } from "../types";

const DEG2RAD = Math.PI / 180;

export function createRoad(data: RoadData): THREE.Group {
  const group = new THREE.Group();

  const roadGeo = new THREE.PlaneGeometry(data.length, data.width);
  const roadMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(data.color),
    roughness: 0.9,
    metalness: 0.0,
  });
  const road = new THREE.Mesh(roadGeo, roadMat);
  road.rotation.x = -Math.PI / 2;
  road.position.y = 0.02;
  road.receiveShadow = true;
  group.add(road);

  const curbGeo = new THREE.PlaneGeometry(data.length, 0.6);
  const curbMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(data.curbColor),
    roughness: 0.85,
  });

  const curbTop = new THREE.Mesh(curbGeo, curbMat);
  curbTop.rotation.x = -Math.PI / 2;
  curbTop.position.set(0, 0.03, -data.width / 2 - 0.3);
  curbTop.receiveShadow = true;
  group.add(curbTop);

  const curbBot = curbTop.clone();
  curbBot.position.set(0, 0.03, data.width / 2 + 0.3);
  group.add(curbBot);

  group.position.set(...data.position);
  group.rotation.set(
    data.rotation[0] * DEG2RAD,
    data.rotation[1] * DEG2RAD,
    data.rotation[2] * DEG2RAD
  );

  return group;
}
